import { TraceAPI } from './api/index.ts';

export const trace = TraceAPI.getInstance();
